import React from "react";
  import { FiChevronDown, FiChevronRight, FiPlusCircle } from "react-icons/fi";
import Navbar from "../../../@shared/navigations/default";
import { Options  } from "../options";
import { experiments, fieldList, jobList } from "./mock";

const AccountSettingPage = () => {
  return (
    <>
    <Navbar />
      <div className="container3">
        <div className="">
          <div>
            <Fields />
            <FeatureEdit />
            {/** <Feature /> **/}
          </div>
          <div>
            <Options path='/account/setting'   /> <br />
          </div>
        </div>
      </div>

    </>
  );
}

export default AccountSettingPage
  

export const Fields = () => {
    const [show,setShow] = React.useState(true)
    const handleShow = (e) => {
        e.preventDefault();
        setShow(!show);
    }
 
    return (
        <div className="fields">
            <ul>
             

                {
                    fieldList.map((item,i)=>(
                        <li  onClick={(e)=>handleShow(e)}>
                            <div>
                                <h4>{item.title}</h4>
                                <p>{item.description}</p>
                            </div>

                            <div className="setting">
                                {!show ? <FiChevronRight />: <FiChevronDown /> }
                            </div>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

 
  
  export const FeatureEdit = ({preview}) => {
    const [show] = React.useState(true)

    let item = {
        title:'Experiment',
        description:'Enter your experiment information'
    }
    const [limit,setLimit] = React.useState(2)
    return (
        <div className="features">
            <div className="heading" >
                <div>
                    <h4>{item?.title}</h4>
                    <p>{item?.description}</p>
                </div>
                <div className="flex-end">
                    {false && !preview && (
                        <FiPlusCircle style={{marginRight:'1em'}} size={20} />
                    )}

                    <div className="setting" >
                        {!show ? <FiChevronRight />: <FiChevronDown /> }
                    </div>
                </div>
                
            </div>

            {
            show && experiments.length > 0 && (<React.Fragment>
                <ul>
                {   experiments.map((item,i)=>
                     true ? 
                     (
                        <li key={'experiences'+i*i}  >
                            <h4 className="title">{item?.position}</h4>
                            <h5 className="name">{item?.company}</h5>
                            {item.start && <p className="date">{item?.start} {` / `} {item?.end ?item?.end : 'Current'}</p>}
                            <p className="description">{item?.description.substr(1,1000)}</p>
                        </li>
                    ):<></>)
                }
                </ul>
                

                { experiments.length>limit  && <div className="button" onClick={()=>{setLimit(jobList?.length)}}><p>Load more</p></div>  }  

            </React.Fragment>)
            }
        </div>
    );
}

